import { sourceHasValidMedia } from "~components/shared/media/";
import {
    type VariationComponent,
    isTextOverMediaItemVariation,
} from "~types/types";
import type { IntegrityStatus } from "~utils/moduleIntegrity";

import {
    LEDE_ITEM_MEDIA_PRIORITY,
    LEDE_ITEM_OVERLAY_MEDIA_PRIORITY,
} from "./LineupContentWeekendLandscape";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    if (!items?.length) return ["This VariationComponent has no items"];

    const [firstItem] = items;

    const priority = isTextOverMediaItemVariation(firstItem.variation)
        ? LEDE_ITEM_OVERLAY_MEDIA_PRIORITY
        : LEDE_ITEM_MEDIA_PRIORITY;

    if (!sourceHasValidMedia(firstItem, priority)) {
        return [
            "The lede item for this module does not have valid media. If you're using an overlay treatment, an image or looping video is mandatory.",
        ];
    }

    return [];
}
